import { createContext } from "react";

/*
 * The security block of the view template a custom card is being rendered
 * inside, as `templateSecurityUI` from getViewTemplates:
 *
 *   { Read: bool, Update: bool, Full: bool }
 *
 * getArticle already hands this to M_CustomCards, which publishes it here so
 * that a control buried anywhere inside the card can ask for it without the
 * card having to drill it down. Undefined outside a custom card, which is what
 * tells usePageSecurity to answer from the page's security instead.
 */
export const TemplateSecurityContext = createContext(undefined);

export default TemplateSecurityContext;
